<ion-header>
  <ion-toolbar>
    <ion-title>debug</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <app-breadcrumb></app-breadcrumb>
  <pre>
    {{ debugService.contentMsg() }}
  </pre>

</ion-content>
